import React, {  } from "react";
import { Card, Grid, Box, Typography, IconButton } from "@mui/material";
import whiteBackIcon from "../../../icons/whiteBackIcon.svg";
import { useStyles } from "../styles";
import { AppConfigSettingsViewEnum } from "../applicationsConfigSettings";
import { CustomQuestionTypeEnum } from "@inosio/payments-sdk";
import CustomQuestionFields from "./CustomQuestionFields";

interface PropsType {
  setView: React.Dispatch<React.SetStateAction<AppConfigSettingsViewEnum>>;
}

export default function ApplicationsCustomQuestions({ setView }: PropsType) {
  const classes = useStyles();

  const getTypography = (text: string, fontWeight: number, fontSize: string, restProps?: object) => (
    <Typography
      sx={{
        fontFamily: 'Work Sans',
        fontWeight: { fontWeight },
        fontSize: { fontSize },
        lineHeight: '22px',
        ...restProps,
      }}
    >
      {text}
    </Typography>
  )

  return (
    <Grid item xs={12} sx={{ mt: 3.5 }}>
      <Card sx={{ display: "flex", flexDirection: "column", color: "#000" }}>
        <Box className={classes.headerContainer} sx={{ backgroundColor: '#BE6531' }}>
          <IconButton
            sx={{ marginRight: "10px", marginTop: "-4px" }}
            onClick={() => setView(AppConfigSettingsViewEnum.Dashboard)}
          >
            <img src={whiteBackIcon} alt="" height="14px" />
          </IconButton>
          {getTypography('Custom Questions', 600, '24px', { color: '#fff' })}
        </Box>

        <Grid container sx={{ p: 2, pt: 2, pb: 1, position: 'relative' }}>


          <CustomQuestionFields CustomQuestionType={CustomQuestionTypeEnum.CustomV1} />
        </Grid>
      </Card>
    </Grid>
  );
}
